module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"{percentage}% on the entire purchase":"{percentage}% on the entire purchase","Discount: {discount}":"Discount: {discount}"},"de":{"{percentage}% on the entire purchase":"{percentage}% auf den gesamten Einkauf","Discount: {discount}":"Rabatt: {discount}"}}')
  delete Component.options._Ctor
}
